import { TeamFormShape } from './TeamModal.types';

export function getDefaultValues(): TeamFormShape {
  return {
    name: '',
    assignedHouseholdIds: [],
    _initialAssignedHouseholdIds: [],
    employeeIds: [],
    _initialEmployeeIds: [],
  };
}
